import { api } from '../lib/api';

export const fetchGuarderias = async (search) => {
  const response = await api.get('/guarderia', {
    params: search ? { search } : undefined,
  });
  return response.data;
};

export const fetchClientesGuarderia = async () => {
  const response = await api.get('/guarderia/opciones/clientes');
  return response.data;
};

export const createGuarderia = async (payload) => {
  const response = await api.post('/guarderia', payload);
  return response.data;
};

export const updateGuarderia = async (id, payload) => {
  const response = await api.put(`/guarderia/${id}`, payload);
  return response.data;
};

export const fetchPagosGuarderia = async (id) => {
  const response = await api.get(`/guarderia/${id}/pagos`);
  return response.data;
};

export const registrarPagoGuarderia = async (id, payload) => {
  const response = await api.post(`/guarderia/${id}/pagos`, payload);
  return response.data;
};
